//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { BenefitList, BenefitWithIconGroup } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import {
  CheckIcon,
  ClinicBenefitImg,
  ClinicBenefitResponsiveImg,
  LivingRoomCatImg,
  LivingRoomCatMobileImg,
} from '@cmp/images';
import { withTranslation } from 'react-i18next'; //------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------

//------------------------------------------------------------------------------
// Constsants ----------------------------------------------------------------------
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class BenefitSection extends React.Component {
  render() {
    const { t, screenName } = this.props;
    const componentClasses = classNames(styles.BenefitSection);
    const CLINIC_BENEFITS = [
      {
        icon: (
          <CheckIcon alt={t('accessibility_Benefit')} className={styles.icon} />
        ),
        text: t('landing_OfferECommerce'),
      },
      {
        icon: (
          <CheckIcon alt={t('accessibility_Benefit')} className={styles.icon} />
        ),
        text: t('landing_NoSetup'),
      },
      {
        icon: (
          <CheckIcon alt={t('accessibility_Benefit')} className={styles.icon} />
        ),
        text: t('landing_OfferTheComplete'),
      },
    ];
    const CLIENT_BENEFITS = [
      {
        icon: (
          <CheckIcon alt={t('accessibility_Benefit')} className={styles.icon} />
        ),
        text: t('landing_FreeShipping'),
      },
      {
        icon: (
          <CheckIcon alt={t('accessibility_Benefit')} className={styles.icon} />
        ),
        text: t('landing_Convenience'),
      },
      {
        icon: (
          <CheckIcon alt={t('accessibility_Benefit')} className={styles.icon} />
        ),
        text: t('landing_EasyToUse'),
      },
    ];

    return (
      <div className={componentClasses}>
        <div
          className={
            screenName === 'About' ? styles.AboutUsContent : styles.Content
          }
        >
          <h1 className={styles.Header}>
            {t('landing_benefitTitle')}
            <br />
            {t('landing_benefitTitle_2')}
          </h1>
          <BenefitWithIconGroup />

          <div className={styles.DescriptionArea}>
            <BenefitList
              title={t('landing_ClinicTitle')}
              benefits={CLINIC_BENEFITS}
              className={styles.ClinicBenefits}
            />
            <BenefitList
              title={t('landing_ClientsTitle')}
              benefits={CLIENT_BENEFITS}
              rightImg={
                screenName === 'About' ? (
                  <>
                    <ClinicBenefitImg
                      className={styles.LivingRoomCatImg}
                      alt={t('accessibility_Benefit')}
                    />
                    <ClinicBenefitResponsiveImg
                      className={styles.LivingRoomCatMobileImg}
                      alt={t('accessibility_Benefit')}
                    />
                  </>
                ) : (
                  <>
                    <LivingRoomCatImg
                      className={styles.LivingRoomCatImg}
                      alt={t('accessibility_Benefit')}
                    />
                    <LivingRoomCatMobileImg
                      className={styles.LivingRoomCatMobileImg}
                      alt={t('accessibility_Benefit')}
                    />
                  </>
                )
              }
            />
          </div>
          {screenName !== 'About' && t('trust_arc_locale') !== 'ja' && (
            <h3 className={styles.BottomText}>
              {t('landing_FreeShippingExcluding')}
            </h3>
          )}
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(BenefitSection);
